import { Avatar } from '@mantine/core';
import { FC } from 'react';
import { ReactComponent as IconPlaceholder } from './img/placeholder.svg';
import { ReactComponent as IconCancel } from '../../assets/img/IconCancel.svg';
import styles from './AvatarMobile.module.scss';

type AvatarMobileProps = {
  size?: number;
  name?: string;
  surname?: string;
  avatar?: string | null;
  isDeleted?: boolean;
};

export const AvatarMobile: FC<AvatarMobileProps> = ({
  size = 24,
  surname,
  name,
  avatar,
  isDeleted = false,
}) => {
  const initials = surname
    ? `${name?.charAt(0)}${surname?.charAt(0)}`.toUpperCase()
    : name?.charAt(0).toUpperCase();

  const showAvatar = Boolean(avatar) && !isDeleted;
  const iconSize = Math.round(size * (16 / 36));

  return (
    <div className={styles.container} style={{ width: size, height: size }}>
      {showAvatar ? (
        <Avatar size={size} src={avatar}>
          {initials}
        </Avatar>
      ) : (
        <IconPlaceholder style={{ height: size, width: size }} />
      )}
      {isDeleted && (
        <IconCancel
          className={styles.avatarCancel}
          style={{ width: iconSize, height: iconSize }}
        />
      )}
    </div>
  );
};
